import DragComponent from './DragComponent';
export default DragComponent;